import { createContext, Dispatch, SetStateAction } from 'react';

interface NavContext {
  hideSidebar: boolean;
  setHideSidebar: Dispatch<SetStateAction<boolean>>;
}

export const NavigationCTX = createContext<NavContext | undefined>(undefined);
